import LandPC from "./widget/pc/pc.vue";
import LandPhone from "./widget/phone/phone.vue";

export default {
    components: {
        LandPC,
        LandPhone
    }
}